<template>

  <HomepageWideLayout>
    <ProgressDots step="1" :steps="['Accept invitation', 'Enter details', 'Place order']" />
    <b-container class="invite-content text-center">
      <h1>Join {{joinTeamName||'Team'}}</h1>

      <h2>You have been invited<br>to order business cards</h2>
      <b-row>
        <b-col md="3"/>
        <b-col md="6">
          <div class="signup-fieldset" v-if="joinTeamLoaded">
            <b-form-input v-model="name" placeholder="Your name" required="required" type="text" class="signup-account-input" autofocus="autofocus" name="name"></b-form-input>
            <b-form-input v-model="email" placeholder="Your Email" required="required" type="email" class="signup-account-input" name="email"></b-form-input>
            <b-form-input v-model="password" placeholder="Password" required="required" type="password" class="signup-account-input" autofocus="autofocus" name="password"></b-form-input>
            <b-btn variant="default" class="wide-btn" size="lg" @click="submit">Join Team</b-btn>
            <div v-if="error" class="error">{{error}}</div>
          </div>
        </b-col>
      </b-row>

      <p class="fineprint">See a mistake or don't want to accept the invite? Just close the window.
      <br>
      Questions? <router-link to="/contact">Contact us</router-link>
      </p>
    </b-container>

  </HomepageWideLayout>

</template>

<style scoped lang="scss">
.invite-content {
  min-height: calc(100vh - 323px);
}

.signup-fieldset {
  display: block;
  margin: 0 auto;
  min-width: 250px;
  max-width: 400px;
  padding-top: 3em;
}



.signup-account-input,
.signup-account-submit  {
  width: 100%;
  font-weight: 400;
  border-radius: 0;
  padding: 10px 20px;
  margin: 10px auto;
}

.wide-btn {
  width: 100%;
}

.fineprint {
  font-size: smaller;
  margin: 3em 0 1em 0;
}

.error {
  color: red;
  text-align: left;
  font-size: smaller;
}
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
export default {
  props: ['team', 'token'],
  data() {
    return {
      name: '',
      email: '',
      password: '',
      error: ''
    }
  },
  computed: mapGetters(['joinTeamName', 'joinTeamLoaded', 'loginErrorText']),
  async mounted() {
    // TODO wait until user is loaded/not loaded
    this.loadJoinTeamData({team: this.team, token: this.token});
  },
  methods: {
    ...mapActions(['signUp', 'loadJoinTeamData']),
    async submit() {
      let req = [];
      if (!this.name) req.push('Name');
      if (!this.email) req.push('Email');
      if (!this.password) req.push('Password');

      if (req.length === 1) {
        this.error = `${req[0]} is required`;
        return;
      }
      if (req.length > 1) {
        let last = req.pop();
        this.error = `${req.join(', ')} and ${last} are required`;
        return;
      }

      await this.signUp({
        team: this.team,
        token: this.token,
        name: this.name,
        username: this.email,
        email: this.email,
        password: this.password,
        confirm_password: this.password
      });
      if (this.loginErrorText) {
        this.error = this.loginErrorText;
      } else {
        this.$router.push('/setup');
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/Join.vue